import React from 'react';
import {
  Table,
  TableCell,
} from '@mairistem/composants';
import {
  map, first, split, findIndex,
} from 'lodash';
import NatJuridiqueCatPesHeader from './NatJuridiqueCatPesHeader';
import NatureJuridiqueCatPesItem from './NatureJuridiqueCatPesItem';
import naturesJuridiquesPes from '../../../../constants/tiers/naturesJuridiquesPes';
import naturesJuridiquesCategoriesPes from '../../../../constants/tiers/naturesJuridiquesCategoriesPes';
import categoriesPes from '../../../../constants/tiers/categoriesPes';
import { ComboboxOption } from '../../../../interfaces/common/ComboxOption';

interface TiersNatureJuridiqueCategoriePesProps {
  onClick: (categorie: string, natureJuridique: string) => void;
  onDoubleClick: VoidFunction;
  categoriePes: string;
  natureJuridiquePes: string;
}

const NatJuridiqueCatPesPicker = ({
  onClick,
  onDoubleClick,
  categoriePes,
  natureJuridiquePes,
}: TiersNatureJuridiqueCategoriePesProps) => {
  const renderRow = (categorie: ComboboxOption): React.JSX.Element => {
    const isActiveRow = first(split(categoriePes, ' ', 1)) === categorie.key;

    const row = map(naturesJuridiquesPes, (naturesJuridique) => {
      const activeCell = first(split(natureJuridiquePes, ' ', 1)) === naturesJuridique.key;

      if (findIndex(naturesJuridiquesCategoriesPes, { key: `${naturesJuridique.key}/${categorie.key}` }) >= 0) {
        return (
          <NatureJuridiqueCatPesItem
            keyNatureJuridique={`${naturesJuridique.key}-${categorie.key}`}
            categorie={categorie.value}
            natureJuridique={naturesJuridique.value}
            activeCell={activeCell}
            onClick={onClick}
            onDoubleClick={onDoubleClick}
          />
        );
      }

      return <TableCell key={`${naturesJuridique.key}-${categorie.key}`} active={activeCell} />;
    });

    return (
      <Table.Row key={categorie.key} active={isActiveRow}>
        <Table.Cell width={2} key={`0-${categorie.key}`}>
          {categorie.text}
        </Table.Cell>
        {row}
      </Table.Row>
    );
  };

  return (
    <Table collapsing compact definition textAlign="center">
      <NatJuridiqueCatPesHeader />
      <Table.Body>
        {map(
          categoriesPes,
          (categorie) => renderRow(categorie),
        )}
      </Table.Body>
    </Table>
  );
};

export default NatJuridiqueCatPesPicker;
